export const SCOREBOARD_TYPE_MANUAL = 'MANUAL';
export const SCOREBOARD_TYPE_AUTOMATIC = 'AUTOMATIC';
export const SCOREBOARD_TYPE_NO_SCOREBOARD = 'NO-SCOREBOARD';
export const SCOREBOARD_TYPE_AUTOMATIC_BURNT = 'AUTOMATIC-BURNT';

export const TEAM_1 = "1";
export const TEAM_2 = "2";